import { setTokenInDB, clearTokenFromDB } from './db';

const KEY_TOKEN = 'SESSION';
const KEY_USERNAME = 'USERNAME';
const KEY_VGM = 'VGM_ENABLED';
const KEY_DELETE = 'DELETE_ENABLED';
const KEY_LOCATION = 'LOT_LOCATION_ENABLED';
const KEY_GALLERY = 'SAVE_TO_GALLERY';
const KEY_ADD_CARGO = 'ADD_CARGO_ENABLED';
const KEY_LANG = 'APP_LANG';

export const getToken = (): string | null => localStorage.getItem(KEY_TOKEN);
export const setToken = (token: string) => {
  localStorage.setItem(KEY_TOKEN, token);
  setTokenInDB(token).catch(() => {});
};

export const getUsername = (): string | null => localStorage.getItem(KEY_USERNAME);
export const setUsername = (u: string) => localStorage.setItem(KEY_USERNAME, u);

// Preferencia de idioma elegida manualmente por el usuario. Si es null, el
// idioma se resuelve automáticamente según el perfil (self-managed → inglés).
export const getLanguagePref = (): string | null => localStorage.getItem(KEY_LANG);
export const setLanguagePref = (lang: string) => localStorage.setItem(KEY_LANG, lang);

// Preferencia de idioma POR USUARIO (email). Namespaced para que dos cuentas en
// el mismo dispositivo no hereden el idioma de la otra: cada usuario recuerda su
// propia elección (login, header o Ajustes) y quien no ha elegido nada obtiene el
// idioma por defecto según su perfil (español para hispanohablantes, inglés para
// self-managed y el resto). Un usuario en español que nunca toca el idioma no
// tiene clave → sigue en español, sin cambios.
const userLangKey = (user: string) => `${KEY_LANG}:${user}`;
export const getUserLanguagePref = (user: string | null): string | null =>
  user ? localStorage.getItem(userLangKey(user)) : null;
export const setUserLanguagePref = (user: string, lang: string) =>
  localStorage.setItem(userLangKey(user), lang);

const KEY_LANG_MIGRATED = 'APP_LANG_MIGRATED_V1';
// Migración de una sola vez: en una versión previa, el toggle de idioma del login
// PERSISTÍA la preferencia, dejando un APP_LANG "pegado" que bloqueaba la
// resolución de idioma por perfil (country/self-managed). Lo limpiamos una única
// vez. A partir de aquí, solo el selector de Ajustes fija una preferencia manual;
// el toggle del login es temporal.
export const migrateLanguagePref = () => {
  if (localStorage.getItem(KEY_LANG_MIGRATED)) return;
  localStorage.removeItem(KEY_LANG);
  localStorage.setItem(KEY_LANG_MIGRATED, '1');
};

export const clearSession = () => {
  localStorage.removeItem(KEY_TOKEN);
  localStorage.removeItem(KEY_USERNAME);
  clearTokenFromDB().catch(() => {});
};

export const getPreferences = () => ({
  vgmEnabled: localStorage.getItem(KEY_VGM) !== 'false',
  deleteEnabled: localStorage.getItem(KEY_DELETE) === 'true',   // default OFF
  locationEnabled: localStorage.getItem(KEY_LOCATION) === 'true', // default OFF
  galleryEnabled: localStorage.getItem(KEY_GALLERY) !== 'false',  // default ON
  addCargoEnabled: localStorage.getItem(KEY_ADD_CARGO) !== 'false', // default ON
});

export const setPreference = (key: 'vgm' | 'delete' | 'location' | 'gallery' | 'addCargo', value: boolean) => {
  const map: Record<string, string> = {
    vgm: KEY_VGM,
    delete: KEY_DELETE,
    location: KEY_LOCATION,
    gallery: KEY_GALLERY,
    addCargo: KEY_ADD_CARGO,
  };
  localStorage.setItem(map[key], String(value));
};

export const isTokenValid = (): boolean => {
  const token = getToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now() + 60000;
  } catch {
    return false;
  }
};
